<template>
    <div id="service-staff-setting" class="shadow-md rounded-item">
        <vx-card>
            <div class="setting-card-hidden">
                <div class="setting-card-scroll">
                    <h4 class="text-2xl font-bold">Flex Checkin Setting</h4>
                    <div class="flex align-center">
                        <vs-switch v-model="flex_checkin" class="my-6" @click.stop="updateFlexCheckinSetting"/>
                        <span class="pl-5">Active Flex Checkin</span>
                    </div>
                </div>
            </div>
        </vx-card>
    </div>
</template>
<script>
export default {
    name: 'flex-checkin-setting',
    data() {
        return {
            flex_checkin: false,
            loaded_data_num: 0,
            isOpenLoading: false,
            action_type: ''
        }
    },
    watch: {
        loaded_data_num: {
            immediate: true,
            handler() {
                if(this.loaded_data_num >= 1) {
                    this.closeLoading();
                } else {
                    this.action_type = "Get Data";
                    this.openLoadingInDiv();
                }
            }
        }
    },
    methods: {
        openLoadingInDiv(){
            this.$vs.loading({
                container: '#app',
                scale: 0.8
            })
            if (this.loadTime) {
                clearTimeout(this.loadTime);
                this.loadTime = null;
            }
            this.isOpenLoading = true;
            this.loadTime = setTimeout( ()=> {
                if(this.isOpenLoading) {
                this.closeLoading();
                this.$vs.dialog({
                    color: 'danger',
                    title: 'Notification',
                    text: this.action_type + ' Flex Checkin Setting Failed',
                    acceptText: 'OK'
                })
                }
            }, 10000);
        },
        closeLoading() {
            this.$vs.loading.close('#app > .con-vs-loading');
            this.isOpenLoading = false;
        },
        updateFlexCheckinSetting() {
            const obj = {
                key: 'config.flex.checkin',
                value: !this.flex_checkin ? 1 : 0
            }
            this.action_type = 'Update';
            this.openLoadingInDiv();
            this.$store.dispatch("appSetting/UPDATE_KEY_STORAGE", obj).then(() => {
                this.closeLoading();
                this.$vs.notify({
                title:'Notification',
                text:'Update Flex Checkin Setting Success',
                color:'success',
                position:'top-right'})
            });
        }
    },
    created() {
        const obj = {
            key: 'config.flex.checkin'
        }

        this.$store.dispatch("appSetting/GET_KEY_STORAGE" ,obj).then(() => {
            this.loaded_data_num++;
            let flex_checkin = this.$store.getters["appSetting/keyStorage"];
            this.flex_checkin = flex_checkin.value == 1 ? true : false;
        }).catch(() => {
            const obj = { 
                key: 'config.flex.checkin',
                value: 0
            }
            this.$store.dispatch("appSetting/ADD_KEY_STORAGE", obj).then(() => {
                this.loaded_data_num++;
            })
        })
    }
}
</script>

